import React from 'react';
import './InvoiceDiscounting.css';
import InvoiceDiscountingBanner from '../images/Invoice-Discounting--banner.jpeg';
import InvoiceDiscountingInner from '../images/Invoice-Discounting-inner-page-scaled.jpeg';

const InvoiceDiscounting = () => {
  return (
    <div className="invoice-discounting-page" style={{ backgroundImage: `url(${InvoiceDiscountingInner})` }}>
      {/* Banner Section */}
      <section className="invoice-discounting-banner">
        <div className="invoice-banner-container">
          <div className="invoice-banner-left">
            <div className="invoice-banner-image" style={{ backgroundImage: `url(${InvoiceDiscountingBanner})` }}>
              <div className="invoice-image-overlay">
                <h1 className="invoice-banner-title">INVOICE DISCOUNTING</h1>
              </div>
            </div>
          </div>
          <div className="invoice-banner-right">
            <div className="invoice-banner-content">
              <h2 className="invoice-banner-subtitle">WE OFFER A FULL RANGE OF INVOICE DISCOUNTING SERVICES</h2>
              <p className="invoice-banner-description">
                Invoice Financing revolutionises the landscape of Micro, Small, and Medium Enterprises (MSMEs), transcending traditional financial boundaries. AFPL introduces this innovative concept, offering a digital haven for MSMEs to flourish. Unlike conventional Invoice Discounting platforms, AFPL extends the benefits of invoice financing to the entire spectrum of MSMEs, facilitating early cash flows in business and creating a level playing field. This Deep-Tier Financing is unsecured in nature, comes at a low cost, and is brought to you with the power of digital. It being off-balance-sheet financing disrupts the norm, providing a seamless platform where MSMEs can securely receive early payments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features/Benefits Section */}
      <section className="invoice-features-section">
        <div className="invoice-features-container">
          <h2 className="invoice-features-heading">FEATURES/BENEFITS</h2>
          <div className="invoice-features-content">
            <div className="invoice-features-image-wrapper">
              <img src={InvoiceDiscountingInner} alt="Invoice Discounting Features" className="invoice-features-image" />
            </div>
            <div className="invoice-features-list">
              <div className="invoice-feature-item">
                <h3 className="invoice-feature-title">UNSECURED FINANCING</h3>
                <p className="invoice-feature-description">Empowers MSMEs by eliminating the need for collateral, thereby enhancing access for a wider variety of businesses.</p>
              </div>
              <div className="invoice-feature-item">
                <h3 className="invoice-feature-title">OFF-BALANCE-SHEET FINANCING</h3>
                <p className="invoice-feature-description">Minimizes the impact on financial statements, allowing MSMEs to maintain a healthier balance sheet.</p>
              </div>
              <div className="invoice-feature-item">
                <h3 className="invoice-feature-title">LOW COST</h3>
                <p className="invoice-feature-description">The platform effect brings in the opportunity of availing financing at a very competitive and affordable Interest rates.</p>
              </div>
              <div className="invoice-feature-item">
                <h3 className="invoice-feature-title">LIMITLESS POSSIBILITIES</h3>
                <p className="invoice-feature-description">Promotes growth without financial constraints, offering MSMEs the freedom to pursue ambitious ventures.</p>
              </div>
              <div className="invoice-feature-item">
                <h3 className="invoice-feature-title">DEEP-TIER DYNAMICS</h3>
                <p className="invoice-feature-description">Extends financial support throughout the supply chain, ensuring comprehensive assistance beyond the immediate transaction.</p>
              </div>
              <div className="invoice-feature-item">
                <h3 className="invoice-feature-title">CREDIT RISK EVALUATION</h3>
                <p className="invoice-feature-description">Utilizes a sophisticated credit risk engine to evaluate businesses, encouraging financial hygiene and discipline.</p>
              </div>
              <div className="invoice-feature-item">
                <h3 className="invoice-feature-title">DIGITAL PLATFORM</h3>
                <p className="invoice-feature-description">Provides a seamless and scalable digital platform, enhancing speed, accessibility, and ease of use for MSMEs.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How Invoice Discounting Works Section */}
      <section className="invoice-how-it-works-section">
        <div className="invoice-how-it-works-container">
          <h2 className="invoice-how-it-works-heading">HOW INVOICE DISCOUNTING WORKS</h2>
          <div className="invoice-steps-grid">
            <div className="invoice-step-card">
              <div className="invoice-step-icon">📱</div>
              <h3 className="invoice-step-title">REGISTRATION</h3>
              <p className="invoice-step-description">
                Digital onboarding process, including eKYC, video verification, e-agreement signing, documents submission, etc., is fast and convenient. The experienced team provide timely and abled support to fast track it.
              </p>
            </div>
            <div className="invoice-step-card">
              <div className="invoice-step-icon">🔍</div>
              <h3 className="invoice-step-title">CREDIT ASSESSMENT</h3>
              <p className="invoice-step-description">
                Through a credit analytics engine (CAE), the model offers digital credit assessment of MSMEs that leverages data available from multiple online data sources such as bank statements, GSTN, TReDS transaction data, etc.
              </p>
            </div>
            <div className="invoice-step-card">
              <div className="invoice-step-icon">✅</div>
              <h3 className="invoice-step-title">CREDIT SANCTION</h3>
              <p className="invoice-step-description">
                Based on the approval of the transactions, the approved funds are disbursed to the vendors, providing them with quick access to working capital for their operations.
              </p>
            </div>
            <div className="invoice-step-card">
              <div className="invoice-step-icon">🤝</div>
              <h3 className="invoice-step-title">TRANSACTION</h3>
              <p className="invoice-step-description">
                Buyer repay the funds when the payment is due, creating a seamless and mutually beneficial financial cycle.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Learn More Section */}
      <section className="invoice-learn-more-section">
        <div className="invoice-learn-more-container">
          <div className="invoice-learn-more-content">
            <h2 className="invoice-learn-more-title">Learn More About Our Services</h2>
            <p className="invoice-learn-more-text">Reach out to us for inquiries.</p>
          </div>
          <a href="/contact" className="invoice-contact-btn">Contact Us</a>
        </div>
      </section>
    </div>
  );
};

export default InvoiceDiscounting;

